// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.loading-logo {
  width: 60px;
  height: 60px;
  animation: pulse-and-spin 2s infinite;
}

@keyframes pulse-and-spin {
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.2) rotate(180deg);
    opacity: 0.7;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
} `, "",{"version":3,"sources":["webpack://./src/context/AuthContext.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF","sourcesContent":[".loading-logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 80vh;\n}\n\n.loading-logo {\n  width: 60px;\n  height: 60px;\n  animation: pulse-and-spin 2s infinite;\n}\n\n@keyframes pulse-and-spin {\n  0% {\n    transform: scale(1) rotate(0deg);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2) rotate(180deg);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1) rotate(360deg);\n    opacity: 1;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
